import { EStorageKeys } from '@app/app.enums';
import { localReturnPath } from '../config/runtime-config';
import { DestroyRef, inject } from '@angular/core';
import { Store } from '@ngrx/store';
import { AuthActions } from '@app/features/auth/state/auth.actions';
import { KeycloakSessionService } from '../services/auth/keycloak-session.service';
import { ProfileApiService } from '../api/profile-api.service';
import { firstValueFrom } from 'rxjs';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

export const authInitializer = async () => {
  const store = inject(Store);
  const session = inject(KeycloakSessionService);
  const profiles = inject(ProfileApiService);
  session.ended$
    .pipe(takeUntilDestroyed(inject(DestroyRef)))
    .subscribe(() => store.dispatch(AuthActions.sessionEnded()));
  try {
    const saved = JSON.parse(
      localStorage.getItem(EStorageKeys.MENU_FAVORITE) ?? 'null',
    );
    const favoriteUrl =
      typeof saved === 'string'
        ? localReturnPath(saved, location.origin)
        : null;
    if (favoriteUrl)
      store.dispatch(AuthActions.setFavoriteUrl({ favoriteUrl }));
  } catch {
    localStorage.removeItem(EStorageKeys.MENU_FAVORITE);
  }
  try {
    const authenticated = await session.initialize();
    const user = authenticated
      ? await firstValueFrom(profiles.getProfile())
      : null;
    store.dispatch(AuthActions.initialized({ user, error: null }));
  } catch {
    store.dispatch(
      AuthActions.initialized({
        user: null,
        error: 'Не удалось открыть сеанс. Повторите вход.',
      }),
    );
  }
};
